import { createContext } from 'react';

import { DropdownInterface, DefaultInterface } from '../../models/services/dropdown-interface';

const DropdownContext = createContext<DropdownInterface>(DefaultInterface);

export { DropdownContext };
